module.exports = __webpack_public_path__ + "img/receipt-lightblue.2296eb9a.svg";